import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Spin,
  Table,
  Input,
  Space,
  Button,
  Popconfirm,
} from "antd";
import Title from "antd/lib/typography/Title";
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { openNotificationWithIcon, FetchURL, addFormData } from "../../../util/help";
import { actHideLoading, actShowLoading } from "../../../actions/actionLoading";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../../util/api";
import {
  deleteTypeCost,
  fetchTypeCost,
} from "../../../actions/actionTypeCosts";

function TypeCosts() {
  const [state, setState] = useState({ searchText: "", searchedColumn: "" });

  const typeCosts = useSelector((state) => state.typeCosts);
  const isLoading = useSelector((state) => state.isLoading);

  const dispatch = useDispatch();
  const getTypeCost = (data) => dispatch(fetchTypeCost(data));
  const showLoading = () => dispatch(actShowLoading());
  const hideLoading = () => dispatch(actHideLoading());
  const DeleteTypeCost = (DESCRIPTION_CODE) =>
    dispatch(deleteTypeCost(DESCRIPTION_CODE));

  useEffect(() => {
    showLoading();
    fetch(FetchURL + "data-basic/type-cost")
      .then((res) => res.json())
      .then((data) => {
        if (data.success === true) {
          getTypeCost(data.data);
          hideLoading();
        }
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    render: (text) =>
      state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setState({ searchText: "" });
  };

  const Delete = (DESCRIPTION_CODE, DESCRIPTION_NAME_VN) => {
    const params = {
      DESCRIPTION_CODE: DESCRIPTION_CODE
    }
    showLoading();
    axios
      .post("data-basic/type-cost/remove", addFormData(params))
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            DeleteTypeCost(DESCRIPTION_CODE);
            hideLoading();
            openNotificationWithIcon(
              "success",
              `Bạn đã xóa thành công ${DESCRIPTION_NAME_VN}`
            );
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    {
      title: "DESCRIPTION CODE",
      dataIndex: "DESCRIPTION_CODE",
      key: "DESCRIPTION_CODE",
      ...getColumnSearchProps("DESCRIPTION_CODE"),
    },
    {
      title: "Tiếng Việt",
      dataIndex: "DESCRIPTION_NAME_VN",
      key: "DESCRIPTION_NAME_VN",
      ...getColumnSearchProps("DESCRIPTION_NAME_VN"),
    },
    {
      title: "Tiếng Hoa",
      dataIndex: "DESCRIPTION_NAME_CN",
      key: "DESCRIPTION_NAME_CN",
      ...getColumnSearchProps("DESCRIPTION_NAME_CN"),
    },
    {
      render: (text, record) => (
        <>
          <Link to={`/Dasboard/chiphi/edit/${record.DESCRIPTION_CODE}`}>
            <Button
              type="primary"
              style={{
                backgroundColor: "#faad14",
                borderColor: "#faad14",
                marginRight: 20,
              }}
              icon={<EditOutlined />}
            >
              <span style={{ marginLeft: 8, color: "white" }}>Sửa</span>
            </Button>
          </Link>

          <Popconfirm
            title="Bạn có chắn chắn xóa?"
            onConfirm={() =>
              Delete(record.DESCRIPTION_CODE, record.DESCRIPTION_NAME_VN)
            }
          >
            <Button type="primary" danger icon={<DeleteOutlined />}>
              Xóa
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <Spin size="large" spinning={isLoading}>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dữ Liệu Cơ Bản</Breadcrumb.Item>
        <Breadcrumb.Item>Chi Phí</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <div style={{ textAlign: "center" }}>
          <Title style={{ color: "#1890ff" }}>Chi Phí</Title>
        </div>
        {/* Button Create */}
        <Button type="primary" style={{ marginBottom: 20 }}>
          <Link to="/Dasboard/chiphi/create">Tạo mới</Link>
        </Button>

        <Table
          dataSource={typeCosts}
          columns={columns}
          rowKey={columns[0].key.toString()}
          pagination={{ position: ["bottomLeft"] }}
        />
      </div>
    </Spin>
  );
}

export default TypeCosts;
